module.exports = __webpack_public_path__ + "img/4.6d1d2457.jpg";